import { extractVerbs } from './extract-verbs'
import {
  iCommunicationModuleConfig,
  iGeneralConfig,
  iPathObj,
} from './types'

export type iExtractPaths = ({
  paths,
  generalConfig,
}: {
  paths: iCommunicationModuleConfig['paths']
  generalConfig: iGeneralConfig
}) => iPathObj

const extractPaths: iExtractPaths = ({ paths, generalConfig }) => {
  const pathObj = {} as iPathObj

  Object.keys(paths).forEach((id) => {
    pathObj[id] = extractVerbs({
      pathName: paths[id].path,
      verbs: paths[id].verbs,
      pathConfig: paths[id],
      generalConfig,
    })
  })

  return pathObj
}

export { extractPaths }
